import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LeadsService } from '../../core/Leads/Leads.service';

@Component({
  selector: 'app-new-lead-alert',
  templateUrl: './new-lead-alert.component.html',
  styleUrls: ['./new-lead-alert.component.css']
})
export class NewLeadAlertComponent implements OnInit {
  username: any = ''
  newLeadData: any = {}
  constructor(private router: Router, public dialogRef: MatDialogRef<NewLeadAlertComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private leadService: LeadsService) {
    if (JSON.stringify(this.data) != '{}') {
      this.newLeadData = this.data;
    }
  }
  ngOnInit() {
    if (sessionStorage.getItem('loginResponse')) {
      const loginResponse = JSON.parse(sessionStorage.getItem('loginResponse') || '{}');
      if (loginResponse && loginResponse.data) {
        this.username = `${loginResponse.data?.user?.first_name || ''} ${loginResponse.data?.user?.last_name || ''}`.trim();
      }
    }
  }

  isLoading: boolean = false;

  navigateToDetails() {
    this.onClose();
    if(this.newLeadData && this.newLeadData.stage_id  == 6){
     this.router.navigate(['/suzuki/non-sales']);
    }else{
     this.router.navigate(['/suzuki/leads']);
    }
    setTimeout(() => {
      this.leadService.changeData(this.newLeadData);
    }, 500);
  }

  onClose(): void {
    this.dialogRef.close();
  }

}
